export class InternalServerApiError extends Error {
  constructor(message: string = 'Internal Server Error') {
    super(message);
    this.name = 'InternalServerApiError';
    Object.setPrototypeOf(this, InternalServerApiError.prototype);
  }
}